// extracted by mini-css-extract-plugin
module.exports = {"grid":"MainPage_grid__24JNg"};